// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class StringValue implements flatbuffers.IUnpackableObject<StringValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): StringValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsStringValue(bb: flatbuffers.ByteBuffer, obj?: StringValue): StringValue {
    return (obj || new StringValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsStringValue(
    bb: flatbuffers.ByteBuffer,
    obj?: StringValue,
  ): StringValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new StringValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): string | null;
  value(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  value(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startStringValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valueOffset, 0);
  }

  static endStringValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createStringValue(
    builder: flatbuffers.Builder,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    StringValue.startStringValue(builder);
    StringValue.addValue(builder, valueOffset);
    return StringValue.endStringValue(builder);
  }

  unpack(): StringValueT {
    return new StringValueT(this.value());
  }

  unpackTo(_o: StringValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): StringValueT {
    const t = new StringValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class StringValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: string | Uint8Array | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const value = this.value !== null ? builder.createString(this.value!) : 0;

    return StringValue.createStringValue(builder, value);
  }

  clone(): StringValueT {
    const obj = new StringValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: StringValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyStringValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
